import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StockCountCreateContext, StockCountCreateValues } from '../../contexts/StockCountCreateContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const StockCountCreateDeleteItemsModal = () => {
  const { isDeleteModalOpen,
    handleClose,
    deleteItems,
    itemsData,
    itemNumber } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const { t } = useTranslation('createStockCount');

  const handleConfirm = () => {
    if (itemNumber !== undefined) {
      const data = itemsData?.filter(item => item.id !== itemNumber);
      deleteItems(data);
    }
    else {
      deleteItems([]);
    }
  };

  return (
    <Dialog open={isDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('deleteItem')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('approvalDialogItemsMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountCreateDeleteItemsModal;